import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { MetricsDisplayGridRowDataFragmentGql } from './MetricsDisplayGridRowDataFragmentGql';

export const TableDownstreamMetricsQueryGql: DocumentNode = gql`
query TableDownstreamMetricsQuery($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  tables(filter: { id: $tableId }) {
    downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...MetricsDisplayGridRowDataFragment
      }
    }
  }
}
${MetricsDisplayGridRowDataFragmentGql}
`;
